// import viewCode from '../components/viewCode.vue'
import store from '@/store'
import vue from 'vue'
// import viewPage from '../components/viewPage'
import docsEdit from '../components/docsEdit.vue'
const that = vue.prototype
export default {
  className: 'Docs',
  perPage: 30,
  fields: [
    {
      // 标题
      name: 'theme',
    },
    {
      // 摘要
      name: 'abstract'
    },
    {
      // 正文
      name: 'content'
    },
    {
      // 图片
      name: 'image'
    }
    // {
    //   name: 'code',
    //   note: '二维码',
    //   view: {
    //     component: viewCode
    //   }
    // }
  ],
  search: [
    'theme'
  ],
  hooks: {
    async afterInsert ({ data, result }) {
      let { data: res } = await that.$tkParse.post('/download', result)
      if (res) {
        await that.$tkParse.put(`/classes/Docs/${result.objectId}`, { image: res.url }).catch(e => {
          that.$notification['error']({
            message: '生成图片失败',
            description: '网络错误,请重试'
          })
        })
      } else {
        that.$notification['error']({
          message: '生成图片失败',
          description: '网络错误,请重试'
        })
      }
    },
    async afterUpdate ({ data, objectId }) {
      // console.log('update', data)
      // if (!(data && data.image)) { // 若没有图片，则生成图片

      // }
    }
  },
  action: {
    create: store.state.user && store.state.user.authority && store.state.user.authority.doc && store.state.user.authority.doc.create ? {
      type: 'list',
      text: '新建',
      icon: 'plus',
      buttonType: 'primary',
      component: 'akModelEditor',
      fieldsPlus: { // 对默认使用ModelEditor的action有效，可以修改fields在编辑时的属性
        image: false, // 隐藏一个字段
      }
    } : false,
    edit: store.state.user && store.state.user.authority && store.state.user.authority.doc && store.state.user.authority.doc.edit ? {
      type: 'row',
      text: '编辑',
      component: docsEdit
      // component: 'akModelEditor',
      // fieldsPlus: { // 对默认使用ModelEditor的action有效，可以修改fields在编辑时的属性
      //   image: false, // 隐藏一个字段
      // }
    } : false,
    delete: store.state.user && store.state.user.authority && store.state.user.authority.doc && store.state.user.authority.doc.del ? {} : false,
    view: store.state.user && store.state.user.authority && store.state.user.authority.doc && store.state.user.authority.doc.view ? {
      type: 'row',
      text: '查看',
      // component: viewPage
      callback: ({ record }) => {
        // window.location.href = `http://doc.jiacai.mokekeji.com/?objectId=${record.objectId}`
        window.open(`https://publicity.mokekeji.com/jiacai?objectId=${record.objectId}`)
      }
    } : false
  }
}
